import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';
import { GiCheckMark } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';
import { FaEdit } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { CgDanger } from "react-icons/cg";
export default function AloWiseWorkerRegReport() {
    let location = useLocation()
    let acl_org = location?.state?.org_id
    const [showList, setList] = useState([])
    function GetChequeInReport() {
        let url = config.url.BOC_URL + "aloWise?acl_org=" + acl_org
        CommonAxiosGet(url).then((response) => {
            if (response.data.status === true) {
                setList(response.data.aloWise);
            }
            else {
                setList([])
            }
        })
    }
    let navigate = useNavigate()
    useEffect(() => { GetChequeInReport() }, [])
    const columns = [
        {
            Header: 'S.NO',
            accessor: (row, index) => index + 1,
            Footer: 'Total',

        },
        {
            Header: 'ALO Org Name',
            accessor: (row) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/MandalWiseRegReport', { state: { status: "own_approved", org_id: row?.alo_org } }) }}>{row?.alo_org_name}</span>,
            // accessor: (row) => row.alo_org_name,
            Footer: '',

        },

        {
            Header: 'Registered on their Own',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "own_total",
                    // Cell: ({ row }) =>
                    //     (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "own_total" ,alo_org:row?.alo_org} }) }}>{row?.original?.own_total}</span>)
                    // ,
                    Footer: 'own_total',
                    tooltipmsg: 'Registered'
                },
                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "own_approved",
                  //  Cell: ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "own_approved", alo_org: row?.alo_org } }) }}>{row?.original?.own_approved}</span>,
                    Footer: 'own_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "own_rejected",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "own_rejected", alo_org: row?.alo_org } }) }}>{row?.original?.own_rejected}</span>),
                    Footer: 'own_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "own_pending",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "own_pending", alo_org: row?.alo_org } }) }}>{row?.original?.own_pending}</span>),
                    Footer: 'own_pending',
                    tooltipmsg: 'Pending'
                },
            ],
        },
        {
            Header: 'Registered By GSWS',
            accessor: 'Registered By GSWS',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "gsws_total",
                  //  Cell: ({ row }) => <span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "gsws_total", alo_org: row?.alo_org } }) }}>{row?.original?.gsws_total} </span>,
                    Footer: 'gsws_total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "gsws_approved",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "gsws_approved", alo_org: row?.alo_org } }) }}>{row?.original?.gsws_approved} </span>),
                    Footer: 'gsws_approved',
                    tooltipmsg: 'Approved'

                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "gsws_rejected",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "gsws_rejected", alo_org: row?.alo_org } }) }}>{row?.original?.gsws_rejected} </span>),
                    Footer: 'gsws_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "gsws_pending",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "gsws_pending", alo_org: row?.alo_org } }) }}>{row?.original?.gsws_pending} </span>),
                    Footer: 'gsws_pending',
                    tooltipmsg: 'Pending'
                },
            ],
            Footer: '',
        },
        {
            Header: 'Registered By Alo',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "alo_total",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "alo_total", alo_org: row?.alo_org } }) }}>{row?.original?.alo_total} </span>),
                    Footer: 'alo_total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "alo_approved",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "alo_approved", alo_org: row?.alo_org } }) }}>{row?.original?.alo_approved} </span>),
                    Footer: 'alo_approved',
                    tooltipmsg: 'Approved'
                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "alo_rejected",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "alo_rejected", alo_org: row?.alo_org } }) }}>{row?.original?.alo_rejected} </span>),
                    Footer: 'alo_rejected',
                    tooltipmsg: 'Rejected'
                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "alo_pending",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "alo_pending", alo_org: row?.alo_org } }) }}>{row?.original?.alo_pending}  </span>),
                    Footer: 'alo_pending',
                    tooltipmsg: 'Pending'

                },
            ],
            Footer: '',

        },
        {
            Header: 'Total',
            columns: [
                {
                    Header: () => (<FaEdit size={19} color='blue' />),
                    accessor: "total",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "total", alo_org: row?.alo_org } }) }}>{row?.original?.total} </span>),
                    Footer: 'total',
                    tooltipmsg: 'Registered'
                },

                {
                    Header: () => (<GiCheckMark size={25} color='green' />),
                    accessor: "approved",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "approved", alo_org: row?.alo_org } }) }}>{row?.original?.approved} </span>),
                    Footer: 'approved',
                    tooltipmsg: 'Approved'

                },
                {
                    Header: () => (<ImCross size={17} color='red' />),
                    accessor: "rejected",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "rejected", alo_org: row?.alo_org } }) }}>{row?.original?.rejected} </span>),
                    Footer: 'rejected',
                    tooltipmsg: 'Rejected'

                },
                {
                    Header: () => (<CgDanger size={24} color='#cf7b06' />),
                    accessor: "pending",
                  //  Cell: ({ row }) => (<span style={{ color: 'Highlight', textDecoration: 'underline' }} onClick={() => { navigate('/WorkerRegistrationReport', { state: { status: "pending", alo_org: row?.alo_org } }) }}>{row?.original?.pending}  </span>),
                    Footer: 'pending',
                    tooltipmsg: 'Pending'

                },
            ],
            Footer: '',

        },
    ]
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="ALO Worker Registration Report" />
            <jnb.Container className="outer-page-content-container">
                <div className="table-responsive">
                    <CommonReactTable columns={columns} data={showList} showFooter="true" filename="DepartmentReport" />
                </div>
            </jnb.Container>
        </React.Fragment>
    )
}
